// extracted by mini-css-extract-plugin
export default {"section":"commercePage_section__xAFzI"};